const mapCategoryLevels = (categoryLevels) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        product_category_level_1: (_b = (_a = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[0]) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : '',
        product_category_level_2: (_d = (_c = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[1]) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : '',
        product_category_level_3: (_f = (_e = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[2]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '',
    });
};
/**
 * Parses category IDs from a defaultFilter string.
 * e.g. "categories:c(100;200;300)" → [100, 200, 300]
 */
const parseCategoryIds = (defaultFilter) => {
    const startKey = 'categories:c(';
    const startIndex = defaultFilter.indexOf(startKey);
    if (startIndex === -1) {
        return [];
    }
    const endIndex = defaultFilter.indexOf(')', startIndex);
    return defaultFilter
        .substring(startIndex + startKey.length, endIndex)
        .split(';')
        .map(id => parseInt(id, 10))
        .filter(id => !isNaN(id));
};
const toLevel = (node, langKey) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        id: String((_b = (_a = node.category) === null || _a === void 0 ? void 0 : _a.categoryId) !== null && _b !== void 0 ? _b : ''),
        description: (_f = (_e = (_d = (_c = node.category) === null || _c === void 0 ? void 0 : _c.categoryTranslatedProperties) === null || _d === void 0 ? void 0 : _d[langKey]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '',
    });
};
const findChild = (parent, id) => { var _a, _b; return ((_a = parent.category) === null || _a === void 0 ? void 0 : _a.categoryId) === id ? parent : (_b = parent.children) === null || _b === void 0 ? void 0 : _b.find(c => { var _a; return ((_a = c.category) === null || _a === void 0 ? void 0 : _a.categoryId) === id; }); };
/**
 * Walks the CategoryHierarchyNode tree following the given category IDs path,
 * collecting translated descriptions at each level.
 *
 * Uses languageAnalytics (fascia main language) for consistent analytics data
 * regardless of the user's browsing language.
 */
export const getCategoryLevelsFromTree = (tree, defaultFilter, languageAnalytics) => {
    if (!tree || !defaultFilter) {
        return [];
    }
    const categoryIds = parseCategoryIds(defaultFilter);
    if (!categoryIds.length) {
        return [];
    }
    const langKey = languageAnalytics.toUpperCase();
    const levels = [];
    let current = tree;
    for (const id of categoryIds) {
        const node = current && findChild(current, id);
        if (!node)
            break;
        levels.push(toLevel(node, langKey));
        current = node;
    }
    return levels;
};
/**
 * Builds a view_category event payload.
 *
 * Category levels are extracted from the CategoryHierarchyNode tree
 * using the fascia's analytics language (languageAnalytics).
 */
export const buildCategoryViewPayload = (categoryLevels) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        category_1: (_b = (_a = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[0]) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : '',
        category_2: (_d = (_c = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[1]) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : '',
        category_3: (_f = (_e = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels[2]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '',
        category_name: (_g = categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels.map(l => l.description).filter(Boolean).join(', ')) !== null && _g !== void 0 ? _g : '',
        domain: window.location.hostname,
    };
};
const getSelectedColor = (product) => { var _a; return (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.find(color => color.colorId === product.selectedColorId); };
const getSelectedSize = (selectedColor, selectedSku) => {
    var _a;
    if (!selectedColor || !selectedSku) {
        return undefined;
    }
    return (_a = selectedColor.sizes) === null || _a === void 0 ? void 0 : _a.find(size => size.sku === selectedSku);
};
/**
 * Builds a view_item event payload from a ProductDetail.
 */
export const buildViewItemPayload = (product, categoryLevels) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const selectedColor = getSelectedColor(product);
    const selectedSize = getSelectedSize(selectedColor, product.selectedSku);
    return Object.assign(Object.assign(Object.assign({ product_id: product.productId, sku_id: (_a = product.selectedSku) !== null && _a !== void 0 ? _a : '', buyingGroup: (_b = product.buyingGroup) !== null && _b !== void 0 ? _b : '' }, mapCategoryLevels(categoryLevels)), { price: (_d = (_c = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.prices) === null || _c === void 0 ? void 0 : _c.SELL) === null || _d === void 0 ? void 0 : _d.original, brand: (_f = (_e = product.brand) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : '', title: (_h = (_g = product.productTranslatedProperties) === null || _g === void 0 ? void 0 : _g.title) !== null && _h !== void 0 ? _h : '', colour: (_j = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.color) !== null && _j !== void 0 ? _j : '', colour_code: (_k = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode) !== null && _k !== void 0 ? _k : '', size: (_l = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.fullCommercialSize) !== null && _l !== void 0 ? _l : '', gender: (_m = product.gender) !== null && _m !== void 0 ? _m : '' }), ((selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.exactAvailability) != null && { stock: selectedSize.exactAvailability }));
};
/**
 * Builds a cart_update event payload.
 */
export const buildCartUpdatePayload = (action, product, basketProducts = [], totalQuantity, pricing) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        action,
        product_id: product.productId,
        sku_id: String((_a = product.sku) !== null && _a !== void 0 ? _a : ''),
        product_list: basketProducts.map(p => {
            var _a, _b, _c;
            return ({
                product_id: p.productId,
                sku_id: p.sku,
                price: (_c = (_b = (_a = p.prices) === null || _a === void 0 ? void 0 : _a.SELL) === null || _b === void 0 ? void 0 : _b.original) !== null && _c !== void 0 ? _c : p.price,
                quantity: p.quantity,
                brand: p.brand,
            });
        }),
        product_ids: basketProducts.map(p => p.productId),
        buyingGroup: (_b = product.buyingGroup) !== null && _b !== void 0 ? _b : '',
        price: product.price,
        total_price: pricing.priceTotalBasket,
        total_quantity: totalQuantity,
        title: (_c = product.title) !== null && _c !== void 0 ? _c : '',
        brand: (_d = product.brand) !== null && _d !== void 0 ? _d : '',
        colour: (_e = product.colour) !== null && _e !== void 0 ? _e : '',
        colour_code: (_f = product.colourCode) !== null && _f !== void 0 ? _f : '',
        gender: (_g = product.gender) !== null && _g !== void 0 ? _g : '',
        size: (_h = product.size) !== null && _h !== void 0 ? _h : '',
    };
};
